import { alpha } from "@mui/system";

const styles = (theme) => ({
  modalConfigSla: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: "16px",

    width: " 90%",
    maxWidth: "800px",
    height: "700px",
    maxHeight: "90vh",
    overflow: "hidden",
  },
  boxLoadingSla: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%", // obrigatório
    width: "100%",
  },
  selectConfig: {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme?.palette?.primary?.main,
      borderWidth: "1px",
    },
    "&.Mui-disabled": {
      color: theme?.palette?.text?.secondary,
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "transparent",
      },
    },

    typography: "overline",
    fontWeight: "bold",
    letterSpacing: "0.5px",
    borderRadius: "8px",

    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme?.palette?.divider,
    },
  },
  boxSelectConfigSla: {
    display: "flex",
    alignItems: "center",
    mr: 1,
    opacity: 0.7,
    color: theme?.palette?.text?.secondary,
  },
  BoxExitModalConfigSla: { position: "absolute", top: "10px", right: "10px" },
  boxTitleModalConfigSla: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  paperItensConfigSla: {
    height: "75%",
    p: 2,
    margin: "0 10px",
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: 1,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  paperEtapaConfigSla: {
    p: 2,
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
  },
  boxTimeConfigSla: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    gap: 1,
    flexDirection: "column",
  },
  refConfigSla: {
    fontWeight: "bold",
    fontSize: "12px",
    opacity: 0.5,
  },
  containerPaperEditConfigSla: {
    display: "flex",
    borderRadius: "10px",
    alignItems: "center",
    gap: 0.5,
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
  },
  boxEditConfigSla: {
    display: "flex",
    alignItems: "center",
    backgroundColor:
      theme.palette.mode === "dark"
        ? alpha(theme.palette.colors.black.dark, 0.4)
        : theme.palette.colors.black.lighter,
    padding: "3px 6px",
    borderRadius: "10px",
    gap: 0.5,
  },
  textFieldEditConfigSla: {
    width: "45px",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      paddingRight: 0,
      backgroundColor: "background.paper",
    },
    "& input": {
      textAlign: "center",
      fontSize: "12px",
    },
  },
  boxTextConfigSla: {
    fontWeight: 500,
    opacity: 0.7,
    fontSize: "12px",
  },
  paperAction: {
    p: 2,
    mb: 1,
    transition: "0.3s",
    "&:hover": { bgcolor: "action.hover" },
    borderColor: "divider",
  },
  titleActions: {
    fontWeight: "700",
    color: "text.secondary",
    mb: 1,
    display: "block",
    letterSpacing: "1px",
  },
});

export default styles;
